
export const curatedPlaylists = [
  {
    id: 1,
    name: 'Heavy Lifting Anthems',
    category: 'Lifting',
    duration: '2h 15m',
    tracks: 45,
    image: 'https://public.readdy.ai/ai/img_res/7a7cb38ea1b4bd1ae2901b5ecf7d38e9.jpg',
    description: 'High-energy tracks to fuel your heaviest lifts and PRs',
    genres: ['Rock', 'Metal', 'Hip-Hop'],
  },
  {
    id: 2,
    name: 'Cardio Flow State',
    category: 'Running',
    duration: '1h 45m',
    tracks: 38,
    image: 'https://readdy.ai/api/search-image?query=runner%20in%20motion%20on%20urban%20street%20at%20dawn%2C%20dynamic%20movement%20blur%2C%20navy%20and%20electric%20blue%20color%20grading%2C%20energetic%20atmosphere%2C%20modern%20athletic%20aesthetic%2C%20clean%20composition%2C%20motivational%20fitness%20photography%2C%20sunrise%20lighting&width=800&height=800&seq=playlist002&orientation=squarish',
    description: 'Perfect tempo for maintaining your running pace and endurance',
    genres: ['Electronic', 'Pop', 'Dance'],
  },
  {
    id: 3,
    name: 'Recovery & Stretch',
    category: 'Relaxing',
    duration: '1h 30m',
    tracks: 25,
    image: 'https://readdy.ai/api/search-image?query=peaceful%20yoga%20and%20stretching%20environment%2C%20soft%20natural%20lighting%2C%20calming%20baby%20blue%20and%20white%20tones%2C%20serene%20atmosphere%2C%20minimalist%20wellness%20aesthetic%2C%20tranquil%20composition%2C%20meditation%20space%2C%20gentle%20morning%20light&width=800&height=800&seq=playlist003&orientation=squarish',
    description: 'Calming sounds for post-workout recovery and mobility work',
    genres: ['Ambient', 'Chill', 'Acoustic'],
  },
  {
    id: 4,
    name: 'Morning Motivation',
    category: 'Lifting',
    duration: '1h 20m',
    tracks: 32,
    image: 'https://readdy.ai/api/search-image?query=sunrise%20gym%20training%20session%2C%20energetic%20morning%20atmosphere%2C%20bright%20electric%20blue%20and%20white%20lighting%2C%20motivational%20fitness%20environment%2C%20modern%20athletic%20aesthetic%2C%20powerful%20composition%2C%20early%20morning%20workout%20energy&width=800&height=800&seq=playlist004&orientation=squarish',
    description: 'Start your day strong with these energizing morning workout tracks',
    genres: ['Hip-Hop', 'Rock', 'Electronic'],
  },
  {
    id: 5,
    name: 'HIIT Beast Mode',
    category: 'Running',
    duration: '45m',
    tracks: 20,
    image: 'https://readdy.ai/api/search-image?query=intense%20interval%20training%20atmosphere%2C%20explosive%20athletic%20movement%2C%20dramatic%20navy%20and%20electric%20blue%20lighting%2C%20high%20energy%20fitness%20environment%2C%20modern%20sports%20aesthetic%2C%20dynamic%20composition%2C%20powerful%20workout%20intensity&width=800&height=800&seq=playlist005&orientation=squarish',
    description: 'Explosive tracks for high-intensity interval training sessions',
    genres: ['Trap', 'EDM', 'Dubstep'],
  },
  {
    id: 6,
    name: 'Evening Wind Down',
    category: 'Relaxing',
    duration: '2h 00m',
    tracks: 30,
    image: 'https://readdy.ai/api/search-image?query=peaceful%20evening%20relaxation%20scene%2C%20soft%20ambient%20lighting%2C%20calming%20baby%20blue%20and%20navy%20gradient%2C%20tranquil%20atmosphere%2C%20minimalist%20wellness%20aesthetic%2C%20serene%20composition%2C%20meditation%20and%20rest%20environment%2C%20gentle%20twilight&width=800&height=800&seq=playlist006&orientation=squarish',
    description: 'Unwind after a hard day with these soothing evening tracks',
    genres: ['Jazz', 'Lo-fi', 'Classical'],
  },
  {
    id: 7,
    name: '80s R&B Top 50',
    category: 'R&B',
    duration: '3h 20m',
    tracks: 50,
    image: 'https://readdy.ai/api/search-image?query=retro%201980s%20rhythm%20and%20blues%20music%20aesthetic%2C%20vintage%20vinyl%20records%20and%20cassette%20tapes%2C%20neon%20pink%20and%20purple%20glow%2C%20retro%20boombox%20and%20turntable%2C%20nostalgic%20eighties%20vibe%2C%20warm%20analog%20tones%2C%20classic%20soul%20music%20atmosphere%2C%20stylized%20retro%20design%20with%20geometric%20shapes&width=800&height=800&seq=playlist80s&orientation=squarish',
    description: 'The definitive 80s R&B collection featuring Whitney Houston, Luther Vandross, Prince, Anita Baker, New Edition, Sade, Teddy Pendergrass, and more timeless classics',
    genres: ['R&B', 'Soul', 'Funk'],
  },
  {
    id: 8,
    name: '90s R&B Top 50',
    category: 'R&B',
    duration: '3h 35m',
    tracks: 50,
    image: 'https://readdy.ai/api/search-image?query=nostalgic 1990s rhythm and blues music aesthetic, vintage CD cases and boom boxes, warm golden amber lighting, retro nineties urban vibe, classic R&B album covers scattered, stylized design with smooth curves, old school music player, warm tones and soft gradients&width=800&height=800&seq=playlist90s&orientation=squarish',
    description: 'The golden era of R&B with Boyz II Men, TLC, Aaliyah, R. Kelly, Mary J. Blige, Jodeci, SWV, Toni Braxton, Usher, and all the 90s slow jams you love',
    genres: ['R&B', 'New Jack Swing', 'Soul'],
  },
  {
    id: 9,
    name: '2000s R&B Top 50',
    category: 'R&B',
    duration: '3h 25m',
    tracks: 50,
    image: 'https://readdy.ai/api/search-image?query=early%202000s%20millennium%20rhythm%20and%20blues%20music%20aesthetic%2C%20sleek%20chrome%20and%20metallic%20surfaces%2C%20cool%20blue%20and%20silver%20tones%2C%20modern%20Y2K%20design%20elements%2C%20futuristic%20music%20studio%20vibes%2C%20glossy%20reflective%20surfaces%2C%20contemporary%20urban%20style%2C%20clean%20minimalist%20design%20with%20metallic%20accents&width=800&height=800&seq=playlist2000s&orientation=squarish',
    description: 'The millennium R&B hits featuring Beyonce, Usher, Alicia Keys, Ne-Yo, Chris Brown, Destiny\'s Child, Ashanti, Mario, Ciara, and the smoothest 2000s tracks',
    genres: ['R&B', 'Pop', 'Hip-Hop Soul'],
  },
];
